<template>
    <div>
        <b-navbar class="menu" toggleable="md" type="dark" style=" overflow-y: hidden">
            <b-navbar-nav class="ml-auto" id="navbar-user">
                <div v-if="tipo !== 3 && !isAsesor" class="dropdown" v-on-clickaway="away" @click="click">
                    <span class="usuario-nav">{{usuario}}</span>
                    <img src="@/assets/images/caret.png" @click="menushow=!menushow" class="caret"/>
                    <div v-if="menushow && close" class="dropdown-content">
                        <p class="sub-usuario-nav">{{usuario}}</p>
                        <p class="submenu-nav">Key: {{codigo}}</p>
                        <p class="submenu-nav">Dni: {{dni}}</p>
                        <button class="navbar-button" @click="logout()">
                            <span class="text-logout">Cerrar sesión</span>
                        </button>
                    </div>
                </div>
                <div v-if="tipo === 3" class="dropdown" v-on-clickaway="away" @click="click">
                    <img src="@/assets/images/logo-default.jpg" class="navbar-img-colegio"/>
                    <span class="usuario-nav">{{usuario}}</span>
                    <img src="@/assets/images/caret.png" @click="menushow=!menushow" class="caret"/>
                    <div v-if="menushow && close" class="dropdown-content">
                        <img src="@/assets/images/logo-default.jpg" class="mt-2 navbar-img-colegio"/>
                        <p v-if="colegio" class="sub-usuario-nav mt-3">{{ colegio.nombre }}</p>
                        <p class="sub-usuario-nav">Convenio Básico</p>
                        <button class="navbar-button" @click="logout()">
                            <span class="text-logout">Cerrar sesión</span>
                        </button>
                    </div>
                </div>
                <div v-if="isAsesor" class="dropdown" v-on-clickaway="away" @click="click">
                    <img src="@/assets/images/caret.png" @click="menushow=!menushow" class="caret2"/>
                    <span class="usuario-nav-2 mr-2">Bienvenido, {{usuario}}</span>
                    <b-avatar></b-avatar>
                    <div v-if="menushow && close" class="dropdown-content">
                        <b-avatar class="mt-2"></b-avatar>
                        <p class="sub-usuario-nav-user mt-2">{{ usuario }}</p>
                        <p class="sub-usuario-nav-email">{{email}}</p>
                        <button class="navbar-button" @click="logout()">
                            <span class="text-logout">Cerrar sesión</span>
                        </button>
                    </div>
                </div>
            </b-navbar-nav>
        </b-navbar>
        <b-navbar
                :style="{ 'background-color': color+'!important'}"
                class="bar-category"
                toggleable=" md"
                type="dark"
        >
            <b-navbar-brand
                    v-if="nav === 'active'"
                    @click="back()"
                    style="z-index: 1; justify-content: center;"
            >
                <img src="@/assets/images/atras.svg" style="cursor: pointer"/>
            </b-navbar-brand>
            <b-navbar-nav>
                <b-nav-item style="z-index: 0;">
                    <span class="nav-content-title titulo-navbar">{{nombre_modulo}}</span>
                </b-nav-item>
            </b-navbar-nav>
        </b-navbar>
    </div>
</template>
<script>
    import {mapState} from "vuex";
    import {mixin as clickaway} from "vue-clickaway";

    export default {
        name: "Navbar",
        mixins: [clickaway],
        data: () => ({
            usuario: "",
            email: "",
            dni: "",
            codigo: "",
            menushow: false,
            close: true,
            tipo: 4,
            colegio: {},
            scrolled: false
        }),
        created() {
            window.addEventListener("scroll", this.handleScroll);
            let userdata = JSON.parse(localStorage.getItem("estudiante"))
                ? JSON.parse(localStorage.getItem("estudiante"))
                : JSON.parse(localStorage.getItem("userdata"));
            this.usuario = userdata.nombre ? userdata.nombre : userdata.name;
            this.email = userdata.email ? userdata.email : userdata.correo;
            this.dni = userdata.dni;
            this.codigo = userdata.key_simulacro;

            let user = JSON.parse(localStorage.getItem("userdata"));
            this.tipo = user.tipo;
            if (user.colegio) {
                this.colegio = user.colegio.colegio;
                //                console.log('aqui colegio', this.colegio)
            }
        },
        destroyed() {
            window.removeEventListener("scroll", this.handleScroll);
        },
        methods: {
            logout() {
                localStorage.clear();
                this.$store.commit("logOut");
                this.$router.push("/");
            },
            back() {
                /*this.$store.dispatch("setNav", false);
                console.log('prueba ddese navbar', this.navRoute);
                let routeNew = this.navRoute;
                this.$store.dispatch("setNavRoute", '');

                if (routeNew) {
                    this.$router.push(this.navRoute);
                } else {
                    this.$router.go(-1);
                }*/
                this.$router.go(-1);
            },
            open: function () {
                this.close = true;
                this.menushow = !this.menushow;
                //                console.log('click open...', this.menushow, this.close )
            },
            click: function () {
                //                console.log(' click dentro!', this.menushow, this.close )
                if (this.close === false) {
                    this.menushow = true;
                    this.close = true;
                }
            },
            away: function () {
                this.close = false;
                //                console.log('click fuera...', this.menushow, this.close )
            },
            handleScroll() {
                this.scrolled = window.scrollY > 0;
            }
        },
        computed: {
            ...mapState(["color", "nombre_modulo", "nav", "navRoute"]),
            isAsesor() {
                return this.$store.getters["isAsesor"];
            }
        },
        watch: {
            scrolled() {
                this.away();
            }
        }
    };
</script>
<style scoped>
</style>
